<template>
	<Teleport to="body">
		<Accessible
			:name="accessibleName"
			trapped
			focusFirstItem
			autoFocus
			trapOn="Tab"
			:wait="250"
			:tabOrder="[{ css: '.modal-close-btn', clickOnEnter: true }, ...tabOrder]"
		>
			<Modal
				:fullscreen="fullscreen"
				:onBeforeClose="onBeforeClose"
				:noEsc="noEsc"
				@close="$emit('close', $event)"
				ref="modal"
				v-bind="$attrs"
			>
				<template v-slot>
					<CloseIcon
						hover
						v-if="!hideClose"
						@click="$refs.modal.close()"
						class="modal-close-btn"
						:aria-label="$t('common_button_close')"
						tabindex="0"
						data-cy="modal-close"
						role="button"
					/>
					<slot />
				</template>
			</Modal>
		</Accessible>
	</Teleport>
</template>

<script>
import { Modal } from '@/components/common'
import { CloseIcon } from '../../icons'
import Accessible from '@/components/common/Accessible'

export default {
	name: 'SimpleModal',
	components: { Modal, CloseIcon, Accessible },
	props: {
		onBeforeClose: {
			type: Function,
		},
		fullscreen: {
			type: Boolean,
			default: null,
		},
		hideClose: {
			type: Boolean,
			default: null,
		},
		noEsc: {
			type: Boolean,
			default: null,
		},
		tabOrder: {
			type: Array,
			default: () => [],
		},
		accessibleName: {
			type: String,
			default: 'simplemodal',
		},
	},
	emits: ['close'],
}
</script>

<style lang="scss" scoped>
.modal-close-btn {
	cursor: pointer;
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 1;
	outline: 0;
	font-size: 24px;
	color: gray;
}
</style>
